export const ROLES = ['admin', 'project_manager', 'site_manager', 'employee'] as const;
export type Role = (typeof ROLES)[number];

export const PROJECT_STATUS = [
  'open',
  'planning',
  'in_progress',
  'delayed',
  'completed',
] as const;
export type ProjectStatus = (typeof PROJECT_STATUS)[number];

export const TASK_STATUS = [
  'open',
  'planning',
  'in_progress',
  'completed',
  'delayed',
] as const;
export type TaskStatus = (typeof TASK_STATUS)[number];

export const CONTACT_TYPES = ['architect', 'client', 'gu', 'other'] as const;
export type ContactType = (typeof CONTACT_TYPES)[number];

export const AUDIT_ENTITIES = [
  'project',
  'task',
  'template',
  'user',
  'contact',
  'section',
  'todo',
] as const;
export type AuditEntity = (typeof AUDIT_ENTITIES)[number];

export const AUDIT_ACTIONS = ['CREATE', 'UPDATE', 'DELETE'] as const;
export type AuditAction = (typeof AUDIT_ACTIONS)[number];

export const PROJECT_STATUS_LABELS: Record<ProjectStatus, string> = {
  open: 'Offen',
  planning: 'Planung',
  in_progress: 'In Bearbeitung',
  delayed: 'Verzug',
  completed: 'Abgeschlossen',
};

export const TASK_STATUS_LABELS: Record<TaskStatus, string> = {
  open: 'Offen',
  planning: 'Planung',
  in_progress: 'In Bearbeitung',
  completed: 'Abgeschlossen',
  delayed: 'Verzug',
};

export const ROLE_LABELS: Record<Role, string> = {
  admin: 'Admin',
  project_manager: 'Projektleiter',
  site_manager: 'Bauleiter',
  employee: 'Mitarbeiter',
};
